/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Boundary_ValueInputs */

const en_how_we_work_brief_boundary_value = /** @type {(inputs: How_We_Work_Brief_Boundary_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A person approves the reply`)
};

const lv_how_we_work_brief_boundary_value = /** @type {(inputs: How_We_Work_Brief_Boundary_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbildi apstiprina cilvēks`)
};

/**
* | output |
* | --- |
* | "A person approves the reply" |
*
* @param {How_We_Work_Brief_Boundary_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_boundary_value = /** @type {((inputs?: How_We_Work_Brief_Boundary_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Boundary_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_boundary_value(inputs)
	return en_how_we_work_brief_boundary_value(inputs)
});